/**
 * Takes a full file path and returns the relative path, removing the leading /pages and the file name
 * @param filePath - The full file path (e.g. '/pages/about/about.tsx')
 * @returns The relative path (e.g. '/about' for '/pages/about/about.tsx', '/' for '/pages/index.tsx')
 * @example
 * getRelativePathFromFilePath('/pages/about/about.tsx') // returns '/about'
 * getRelativePathFromFilePath('/pages/index.tsx') // returns '/'
 * getRelativePathFromFilePath('/pages/about/team/team.tsx') // returns '/about/team'
 */ export const getRelativePathFromFilePath = (filePath: string) => {
  const path = filePath.startsWith("/") ? filePath.slice(1) : filePath;
  const parts = path.split("/");
  parts.shift();
  parts.pop();

  if (parts.length === 0) {
    return "/";
  }
  return `/${parts.join("/")}`;
};

/**
 * Takes a full file path and returns the file name
 * @param filePath - The full file path (e.g. '/pages/about/about.tsx')
 * @returns The file name (e.g. 'about.tsx' for '/pages/about/about.tsx')
 * @example
 * getFileNameFromFilePath('/pages/about/about.tsx') // returns 'about.tsx'
 */
export const getFileNameFromFilePath = (filePath: string) => {
  const path = filePath.startsWith("/") ? filePath.slice(1) : filePath;
  const parts = path.split("/");
  return parts.pop() ?? "";
};
